export default __webpack_public_path__ + "static/media/conveyor.15b44caf.svg";